import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * PrivateRoute - 로그인 여부를 검사하는 보안 라우트
 * 
 * @description
 * localStorage에 저장된 로그인 상태를 확인하여
 * 로그인된 사용자만 보호된 페이지에 접근할 수 있도록 합니다.
 * 
 * @param {React.ReactNode} children - 보호할 컴포넌트
 * @returns {React.ReactElement} 로그인 상태에 따라 children 또는 Navigate
 */
function PrivateRoute({ children }) {
  // localStorage에서 로그인 상태 확인
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  // 로그인 상태가 아니면 로그인 페이지로 리다이렉트
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // 로그인 상태면 요청한 페이지 보여주기
  return children;
}

export default PrivateRoute;
